import { render, staticRenderFns } from "./HelpAndSupport.vue?vue&type=template&id=89c45230&"
import script from "./HelpAndSupport.vue?vue&type=script&lang=js&"
export * from "./HelpAndSupport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports